export default "packs/log-in-background-image-d1a53c5a89de5ed6c7466440e80da338.png";